import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { faTools } from '@fortawesome/free-solid-svg-icons';
import { getAssessmentsList, editAssessment, createAssessment } from '../../../actions/assessments';
import { getAllSkills } from '../../../actions/skills';
import ListPageHeader from '../../common/lists/ListPageHeader';
import Loader from '../../common/ui/Loader';
import AssessmentItem from './AssessmentItem';

class Assessments extends Component {
  static propTypes = {
    assessmentsList: PropTypes.array.isRequired,
    getAssessmentsList: PropTypes.func.isRequired,
    editAssessment: PropTypes.func.isRequired,
    createAssessment: PropTypes.func.isRequired,
    getAllSkills: PropTypes.func.isRequired
  };

  componentDidMount () {
    this.setState({ isLoading: true });
    Promise.all([
      this.props.getAllSkills(),
      this.props.getAssessmentsList()
    ]).then(() => this.setState({ isLoading: false }));
  };

  state = {
    isLoading: false,
    newAssessmentFormIsOpen: false
  };

  openNewAssessmentForm = () => {
    this.setState({
      newAssessmentFormIsOpen: true
    });
  };

  closeNewAssessmentForm = () => {
    this.setState({
      newAssessmentFormIsOpen: false
    });
  };

  render () {
    const { assessmentsList, getAssessmentsList, editAssessment, createAssessment, skillsList } = this.props;
    const { isLoading, newAssessmentFormIsOpen } = this.state;
    return (
      <Fragment>
        <ListPageHeader onClick={this.openNewAssessmentForm} icon={faTools} title='Assessments' />
        { newAssessmentFormIsOpen && (
          <div className='row'>
            <AssessmentItem
              isCreating
              closeNewAssessmentForm={this.closeNewAssessmentForm}
              createAssessment={createAssessment}
              getAssessmentsList={getAssessmentsList}
              skillsList={skillsList}
            />
          </div>
        )}
        { isLoading ? <div className='loader-wrapper'><Loader /></div> : (
          <div className='row'>
            { assessmentsList && assessmentsList.length > 0 && assessmentsList.map(assessment => (
              <AssessmentItem
                key={assessment.id}
                assessment={assessment}
                editAssessment={editAssessment}
                getAssessmentsList={getAssessmentsList}
                skillsList={skillsList}
              />
            ))}
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  assessmentsList: state.assessments.assessmentsList,
  skillsList: state.skillsList
});

const mapDispatchToProps = {
  getAssessmentsList,
  editAssessment,
  createAssessment,
  getAllSkills
};

export default connect(mapStateToProps, mapDispatchToProps)(Assessments);



// WEBPACK FOOTER //
// ./src/components/app/assessments/index.js